import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            话题热度
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base max-w-2xl mx-auto">
            全网热议的剧集话题都在这里，吃瓜视频带你紧跟追剧潮流
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.name}
              href={topic.href}
              className="cursor-pointer group inline-flex items-center gap-2.5 px-4 md:px-5 py-2.5 md:py-3 rounded-full bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200"
            >
              <span className="text-sm md:text-base font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 group-hover:bg-primary-100 group-hover:text-primary-600 px-2 py-0.5 rounded-full transition-colors whitespace-nowrap">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}